const baseUrl = 'https://api.we-trust.com.cn/' // 真实
//const baseUrl = 'https://localhost:44338/'// 本地测试
export default baseUrl



// WEBPACK FOOTER //
// ./src/utils/baseURL.js